import React from 'react';
import PrevRedButton from '../PrevRedButton/PrevRedButton';
import './PreviousApplicationMenu.css';

const PreviousApplicationMenu = (props) => {
    return (
        <div className="PreviousApplicationMenu">
            <h3 className="PreviousApplicationMenu__title">{props.title}</h3>
            <div className="PreviousApplicationMenu__line" />
            <p className="PreviousApplicationMenu__date">{props.date}</p>
            <div className="PreviousApplicationMenu__name_check">
                <p className="PreviousApplicationMenu__name">{props.name}</p>
                <div className="PreviousApplicationMenu__check" />
            </div>
            <p className="PreviousApplicationMenu__description">{props.description}</p>
            <PrevRedButton
                name={props.buttonName}
                clicked={props.clicked}
                disabled={props.buttonDisabled}
            />
        </div>
    )
}

export default PreviousApplicationMenu;